"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactIdleTimer = _interopRequireDefault(require("react-idle-timer"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var RouteLogger = /*#__PURE__*/function (_react$default$PureCo) {
  function RouteLogger() {
    _classCallCheck(this, RouteLogger);
    return _callSuper(this, RouteLogger, arguments);
  }
  _inherits(RouteLogger, _react$default$PureCo);
  return _createClass(RouteLogger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        history = _this$props.history,
        logEvent = _this$props.logEvent,
        location = _this$props.location;
      console.log(location);
      this.unlisten = history.listen(function (location, action) {
        if (action === 'POP') {
          if (location.pathname === '/' || location.pathname === '') {
            console.log("Going back to home");
            logEvent('pageLoaded', {
              pageId: 'index'
            });
          } else {
            var pageMatch = location.pathname.match(/\/page\/([^\/]+)/);
            if (pageMatch) {
              var pageId = pageMatch[1];
              console.log("Going back to page: ".concat(pageId));
              logEvent('pageLoaded', {
                pageId: pageId
              });
            }
          }
        } else if (action === 'REPLACE' && (location.pathname === '/' || location.pathname === '')) {
          console.log("Reset to home");
          logEvent('pageLoaded', {
            pageId: 'index'
          });
        } else if (action === 'PUSH') {
          if (location.pathname === '/' || location.pathname === '') {
            console.log("Going to home");
            logEvent('pageLoaded', {
              pageId: 'index'
            });
          } else {
            var _pageMatch = location.pathname.match(/\/page\/([^\/]+)/);
            if (_pageMatch) {
              var _pageId = _pageMatch[1];
              console.log("Going to page: ".concat(_pageId));
              logEvent('pageLoaded', {
                pageId: _pageId
              });
            }
          }
        }
      });
    }
  }, {
    key: "onIdle",
    value: function onIdle() {
      var _this$props2 = this.props,
        logEvent = _this$props2.logEvent,
        history = _this$props2.history;
      var pageMatch = history.location.pathname.match(/\/page\/([^\/]+)/);
      var pageId;
      if (pageMatch) {
        pageId = pageMatch[1];
      } else if (history.location === '/') {
        pageId = 'index';
      }
      logEvent('timeout', {
        pageId: pageId
      });
      history.replace('/');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!!this.unlisten) {
        console.log('Unlistening to route events');
        this.unlisten();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactIdleTimer.default, {
        element: document,
        onIdle: this.onIdle.bind(this),
        timeout: this.props.idleTimeoutMs || 1000 * 60 * 4
      }), this.props.children);
    }
  }]);
}(_react.default.PureComponent);
_defineProperty(RouteLogger, "whyDidYouRender", true);
var _default = exports.default = (0, _reactRouterDom.withRouter)(RouteLogger);